import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlockUIComponent } from './block-ui.component';

@NgModule({
  imports: [CommonModule],
  declarations: [BlockUIComponent],
  exports: [BlockUIComponent]
})
export class AppBlockUIModule {}
